import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { ReactComponent as CloseIcon } from '@doveconviene/sf-ui/icons/close_circle.svg'
import Icon from '../../../ui/Icon'

const StyledCloseButton = styled.div(({ theme: { colors } }) => ({
  color: colors.primary,
  cursor: 'pointer',
  display: 'flex',
  position: 'absolute',
  top: 0,
  right: 0,
  padding: 'inherit',
}))

const StyledCloseIcon = styled.div(({ theme: { spaces } }) => ({
  flex: '0 0 auto',
  width: `${spaces.default * 1.2}px`,
  height: `${spaces.default * 1.2}px`,
}))

const StyledCloseLabel = styled.span({
  margin: 0,
  marginRight: 5,
  display: 'inline-block',
})

const CloseCTA = ({
  label,
  onClick = () => false,
}) => (
  <StyledCloseButton onClick={onClick} data-test="ExpandableDrawerCloseCTA">
    {label && (
      <StyledCloseLabel>{label}</StyledCloseLabel>
    )}
    <StyledCloseIcon>
      <Icon>
        <CloseIcon />
      </Icon>
    </StyledCloseIcon>
  </StyledCloseButton>
)

CloseCTA.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

CloseCTA.defaultProps = {
  label: '',
}

CloseCTA.displayName = 'ExpandableDrawerCloseCTA'
CloseCTA.whyDidYouRender = true

export default CloseCTA
